import { graphql } from 'react-apollo';
import { savePreference } from 'chameleon/packages/blue-book-player/queries/user';
import { me as meQuery } from 'legacy/src/queries';

export const withSavePreference = graphql(savePreference, {
  name: 'savePreference',
});
export const withMeQuery = graphql(meQuery, { name: 'meQuery' });
